const GA_MEASUREMENT_ID = "G-QT9DN06M1V"

// klang.ai's CloudFront distribution serves PostHog under /k7 and the Google
// tag gateway under /m7q, so both load from our own domain and ad blockers stop
// dropping attribution. Only production has those paths: staging is a bare S3
// website and localhost has no proxy, so they keep talking to the vendors.
const FIRST_PARTY_HOSTS = ["klang.ai", "www.klang.ai"]
const POSTHOG_PROXY_PATH = "/k7"
const GTAG_GATEWAY_PATH = "/m7q"

module.exports = {
  GA_MEASUREMENT_ID,
  FIRST_PARTY_HOSTS,
  POSTHOG_PROXY_PATH,
  GTAG_GATEWAY_PATH,
}
